<template>
  <div class="thirteen">
    <h4 class="before:bg-secondary after:bg-secondary text-primary">
      <slot></slot>
    </h4>
  </div>
</template>

<script setup></script>

<style scoped>
  .thirteen {
    display: inline-block;
    padding: 0px 3px;
  }
  .thirteen h1 {
    position: relative;
    font-size: 1rem;
    font-weight: 1rem;
    letter-spacing: 0px;
    text-transform: uppercase;
    width: fit-content;
    text-align: center;
    margin: auto;
    white-space: nowrap;
    padding: 5px 3px 3px 3px;
  }
  .thirteen h1:before,
  .thirteen h1:after {
    /* background-color: #c50000; */
    position: absolute;
    content: '';
    height: 7px;

    width: 7px;
    border-radius: 50%;
    bottom: 12px;
  }
  .thirteen h1:before {
    left: -20px;
  }
  .thirteen h1:after {
    right: -20px;
  }

  .zoomup {
    animation: zoomup 4s linear;
    animation-delay: calc(100ms);
  }

  @keyframes zoomup {
    0%,
    100% {
      filter: blur(1px);
      box-shadow:
        0 0 10px var(--color-secondary),
        0 0 20px var(--color-secondary),
        0 0 30px var(--color-secondary),
        0 0 40px var(--color-secondary),
        0 0 60px var(--color-secondary),
        0 0 80px var(--color-secondary);
    }

    5%,
    95% {
      filter: blur(0);
      box-shadow: none;
    }
  }
</style>
